// import { Toaster } from '@blogging/ui'
import { Outlet } from 'react-router-dom'

export function DashboardLayout() {
  return (
    <main role="main" className="min-h-screen bg-background">
      <Outlet />
      {/* <Toaster /> */}
    </main>
  )
}
